<template>
  <div>
    <v-container>
      <v-layout row wrap justify-space-around>
        <v-flex xs2>
          <v-text-field
            v-model="size"
            label="Size"
            placeholder="Optional"
          ></v-text-field>
        </v-flex>
        <v-flex xs2>
          <choice-list :config="subTypeConfig"></choice-list>
        </v-flex>
      </v-layout>
    </v-container>
    <standard-actions
      @save="save"
      @cancel="cancel"
      @close="$emit('close')"
      :save-button="{ name: 'Submit', disabled: !canProceed }"
      :cancel-button="{ name: 'Back' }"
    ></standard-actions>
  </div>
</template>

<script>
import standardActions from '../standardActions'
import choices from '../../autocompletes/choices'

export default {
  name: 'storage',
  components: {
    'standard-actions': standardActions,
    'choice-list': choices
  },
  computed: {
    canProceed () {
      return this.subTypeConfig.id > -1
    }
  },
  data () {
    return {
      size: '',
      subTypeConfig: {
        id: 0,
        label: 'Sub Type',
        appName: 'parts',
        modelName: 'supplies',
        fieldName: 'sub_type'
      }
    }
  },
  methods: {
    save () {
      const details = {
        size: this.size ? this.size : 'NA',
        sub_type_id: this.subTypeConfig.id
      }
      this.$emit('save', details)
    },

    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>
